import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faFolderOpen, faHashtag, faSave, faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_operador: '',
        ano_liquidacion: '',
        mes_liquidacion: '',
        departamento: '',
        municipio: '',
        tipo_poblacion: '',
        files: '',
        anos: [],
        meses: [],
        departamentos: [],
        municipios: [],
        operadores: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    cambioValorFiles = (e) => {
        this.setState({ files: e.target.files });
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { id_operador, ano_liquidacion, mes_liquidacion, departamento, municipio, tipo_poblacion, files } = this.state;
        var errores = [];
        if (!id_operador) { errores.push("error_id_operador"); }
        if (!ano_liquidacion) { errores.push("error_ano_liquidacion"); }
        if (!mes_liquidacion) { errores.push("error_mes_liquidacion"); }
        if (!departamento) { errores.push("error_departamentoo"); }
        if (!municipio) { errores.push("error_municipio"); }
        if (!tipo_poblacion) { errores.push("error_tipo_poblacion"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        for (let i = 0; i < files.length; i++) {
            formData.append(files[i].name, files[i])
        }
        var nombre_departamento = document.getElementById('departamento');
        var nombre_municipio = document.getElementById('municipio');
        formData.append('nombre_departamento', nombre_departamento.options[nombre_departamento.selectedIndex].text);
        formData.append('nombre_municipio', nombre_municipio.options[nombre_municipio.selectedIndex].text);
        Swal.showLoading();
        authAxios.post("archivos_catastro/cargar_liquidaciones", formData)
            .then((datosRespuesta) => {
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
               
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Cargue Liquidaciones!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterCargueLiquidaciones");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Cargue Liquidaciones!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    // cargarMeses = () => {
    //     Swal.showLoading();
    //     var ano_liquidacion = document.getElementById("ano_liquidacion").value;
    //     this.setState({ mes_liquidacion: '', departamento: '', municipio: '', meses: [], departamentos: [], municipios: [] });
    //     authAxios.get("archivos_catastro/meses_liquidacion/" + ano_liquidacion)
    //         .then((datosRespuesta) => {
    //             console.log(datosRespuesta.data);
    //             var status = datosRespuesta.data.status;
    //             if (status) {
    //                 Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
    //                 window.localStorage.clear();
    //                 window.location.href = '/';
    //             }
    //             this.setState({ datosCargados: true, meses: datosRespuesta.data, load: '' });
    //             Swal.close();
    //         })
    //         .catch(console.log);
    // }
    // cargarDepartamentos = () => {
    //     Swal.showLoading();
    //     var ano_liquidacion = document.getElementById("ano_liquidacion").value;
    //     var mes_liquidacion = document.getElementById("mes_liquidacion").value;
    //     this.setState({ departamento: '', municipio: '', departamentos: [], municipios: [] });
    //     authAxios.get("archivos_catastro/departamentos/" + ano_liquidacion + "/" + mes_liquidacion)
    //         .then((datosRespuesta) => {
    //             console.log(datosRespuesta.data);
    //             var status = datosRespuesta.data.status;
    //             if (status) {
    //                 Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
    //                 window.localStorage.clear();
    //                 window.location.href = '/';
    //             }
    //             this.setState({ datosCargados: true, departamentos: datosRespuesta.data, load: '' });
    //             Swal.close();
    //         })
    //         .catch(console.log);
    // }
    // cargarMunicipios = () => {
    //     Swal.showLoading();
    //     var ano_liquidacion = document.getElementById("ano_liquidacion").value;
    //     var mes_liquidacion = document.getElementById("mes_liquidacion").value;
    //     var departamento = document.getElementById("departamento").value;
    //     this.setState({ municipio: '', municipios: [] });
    //     authAxios.get("archivos_catastro/municipios/" + ano_liquidacion + "/" + mes_liquidacion + "/" + departamento)
    //         .then((datosRespuesta) => {
    //             console.log(datosRespuesta.data);
    //             var status = datosRespuesta.data.status;
    //             if (status) {
    //                 Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
    //                 window.localStorage.clear();
    //                 window.location.href = '/';
    //             }
    //             this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
    //             Swal.close();
    //         })
    //         .catch(console.log);
    // }
    cargarMunicipios() {
        var id_departamento = document.getElementById('departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("operadores/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta.data);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, operadores: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("archivos_catastro/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta.data);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anos: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { anos, meses, departamentos, municipios, operadores } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>CARGUE LIQUIDACIONES OPERADORES DE RED</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id='form'>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-4">
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="id_operador">Operador</label>
                                                    <select name="id_operador"
                                                        id="id_operador"
                                                        className={((this.verificarError("error_id_operador")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Operador</option>
                                                        {
                                                            operadores.map((itemOperadores) => (
                                                                <option key={itemOperadores.ID_OPERADOR} value={itemOperadores.ID_OPERADOR}>{itemOperadores.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Operador</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="ano_liquidacion">Año</label>
                                                    <select name="ano_liquidacion"
                                                        id="ano_liquidacion"
                                                        className={((this.verificarError("error_ano_liquidacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Año</option>
                                                        {
                                                            anos.map((itemAnos, index) => (
                                                                <option key={index} value={itemAnos.ANO_FACTURA}>{itemAnos.ANO_FACTURA}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Año</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="mes_liquidacion">Mes</label>
                                                    <select name="mes_liquidacion"
                                                        id="mes_liquidacion"
                                                        className={((this.verificarError("error_mes_liquidacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Mes</option>
                                                        <option value="Enero">ENERO</option>
                                                        <option value="Febrero">FEBRERO</option>
                                                        <option value="Marzo">MARZO</option>
                                                        <option value="Abril">ABRIL</option>
                                                        <option value="Mayo">MAYO</option>
                                                        <option value="Junio">JUNIO</option>
                                                        <option value="Julio">JULIO</option>
                                                        <option value="Agosto">AGOSTO</option>
                                                        <option value="Septiembre">SEPTIEMBRE</option>
                                                        <option value="Octubre">OCTUBRE</option>
                                                        <option value="Noviembre">NOVIEMBRE</option>
                                                        <option value="Diciembre">DICIEMBRE</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Año</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="departamento">Departamento</label>
                                                    <select name="departamento"
                                                        id="departamento"
                                                        className={((this.verificarError("error_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_TABLA} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="municipio">Municipio</label>
                                                    <select name="municipio"
                                                        id="municipio"
                                                        className={((this.verificarError("error_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipios.map((itemMunicipios) => (
                                                                <option key={itemMunicipios.ID_TABLA} value={itemMunicipios.ID_MUNICIPIO}>{itemMunicipios.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="tipo_poblacion">Tipo Población</label>
                                                    <select name="tipo_poblacion"
                                                        id="tipo_poblacion"
                                                        className={((this.verificarError("error_tipo_poblacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo Población</option>
                                                        <option value="1">RURAL</option>
                                                        <option value="2">URBANO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Población</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="files">Archivos Liquidaciones</label>
                                                    <div className='input-group input-group-sm mb-3'>
                                                        <label className="input-group-text label_files" htmlFor="files"><FontAwesomeIcon icon={faFolderOpen} />&nbsp;&nbsp;Seleccionar Archivo(s) </label>
                                                        <input className="form-control form-control-sm" type="file" id="files" multiple onChange={this.cambioValorFiles} />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label style={{ color: '#FFFFFF' }} htmlFor="upload-files">Subir Archivo(s)</label>
                                                    <button type="submit" className="btn btn-success btn-sm" id='upload-files' name='upload-files'><FontAwesomeIcon icon={faUpload} />&nbsp;&nbsp;Subir Archivo(s)</button>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-12'>
                                                    <div className="progress">
                                                        <div style={{ width: "0%" }} className="progress-bar progress-bar-striped progress-bar-animated" id='progress_files' role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-xl-12 text-center'>
                                                    <div className="btn-group" role="group" aria-label="">
                                                        <Link className="btn btn-danger btn-sm" to={"/MasterCargueLiquidaciones"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN ARCHIVO CARGADO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <div id='informacion_cargada'></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;